import { useEffect } from "react";
import { TMobileFullscreenVariant } from "@/common/services/experiment/constants";
import {
  resolveMobileFullscreenVariant,
  useMobileFullscreenExperimentStore,
} from "@/common/services/experiment/mobileFullscreenExperiment";

export const useMobileFullscreenVariant = (enabled: boolean = true): TMobileFullscreenVariant => {
  const variant = useMobileFullscreenExperimentStore((state) => state.variant);

  useEffect(() => {
    if (enabled) {
      void resolveMobileFullscreenVariant();
    }
  }, [enabled]);

  return variant;
};
